/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit AddAction.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import * as fromFlow from 'Logic/ViewsFlow.js'
import ButtonGreen from 'DesignSystem/ButtonGreen/view.js'
import Info from 'DesignSystem/Info/view.js'
import React from 'react'



export default function AddAction({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  viewPath= "/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Choice/AddAction"
}) {
    
    
    
    let flow = fromFlow.useFlow()
let setFlowTo = fromFlow.useSetFlowTo(viewPath)
    
    

  return (<React.Fragment
>
<ButtonGreen
 data-testid="AddAction.ButtonGreen"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Choice/AddAction"
viewPath={`${viewPath}/ButtonGreen`}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../../Add'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../../Add'))}
 text="Add and include enrollment data"
/>
<Info
 data-testid="AddAction.Info"
 data-view-path="/App/MyAccount/Content/Profile/Content/Employees/AddItem/Content/Choice/AddAction"
viewPath={`${viewPath}/Info`}
 textAlign="center"
 marginTop={16}
 fontSize={12}
 text="Enrollment has already occurred. The employee will not be allowed to change their plan type or number of enrolled dependents. They will review their personal information, designate PCDs for covered members, and accept terms and conditions."
/>
{children}
</React.Fragment>)
}